import { Link } from 'react-router-dom';
import { Avatar, AvatarProps, Text } from 'rizzui';
import cn from '../../utils/classNames';

interface AvatarCardProps {
    src: string;
    name: string;
    className?: string;
    textClassName?: string;
    description?: string;
    avatarProps?: AvatarProps;
    hideText?: boolean;
    link?: string;
}

export default function AvatarCard({
    src,
    name,
    className,
    textClassName,
    description,
    avatarProps,
    hideText = false,
    link,
}: AvatarCardProps) {
    return (
        <figure className={cn('flex items-center gap-3', className)}>
            <Avatar name={name} src={src} rounded='sm' {...avatarProps} />
            <figcaption className="grid gap-0.5">
                {!hideText && !link && (
                    <Text className={cn('font-lexend text-sm font-medium text-gray-900 dark:text-gray-700', textClassName)}>
                        {name}
                    </Text>
                )}
                {!hideText && link && (
                    <Link to={link}>
                        <Text className={cn('font-bold text-primary', textClassName)}>{name}</Text>
                    </Link>
                )}
                {description && !hideText && (
                    <Text className={cn('text-[13px] text-gray-500', textClassName)}>{description}</Text>
                )}
            </figcaption>
        </figure>
    );
}